import axiosClient from "sharedServices/api/axios.services";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import { InventoryPricingIssueRes, LongInventoryData, PricingResolutionMasterData } from "models/interfaces";
import { StubHubRoutesEnum } from "models/enums/apiRoutes/stubHubApiRoutes";
import { longInventoryType } from "models/types";

class LongInventoryService {
    public longInventoryData = async (longInventoryRequest: longInventoryType) => {
        return axiosClient.get<IApiBaseResponse<LongInventoryData>
        >(StubHubRoutesEnum.LONG_INVENTORY, {
            params: longInventoryRequest
        })
    }
    public getPricingResolution = async () => {
        return axiosClient.get<IApiBaseResponse<PricingResolutionMasterData[]>
        >(StubHubRoutesEnum.PRICING_RESOLUTIONS, {
            params: null
        })
    }
    
    public savePricingResolution = async (inventoryPricingIssueRes: InventoryPricingIssueRes) => {
        return axiosClient.patch<IApiBaseResponse<boolean>>(
          StubHubRoutesEnum.SAVE_PRICING_RESOLUTIONS,
          {
            ...inventoryPricingIssueRes,
          }
        );
      };
}

export { LongInventoryService }